import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class TruncationService {
  /**
   *
   * Truncates 2 strings so the fit in a specific size
   *
   * Theres 4 cases here
   * - No truncation
   * - String A truncation
   * - String B truncation
   * - Truncation of both
   *
   *
   * This method balances them so the total string length is always the same, regardless of which ones need to be
   * truncated.
   *
   * Eg.
   * - Courthouse: Brisbane Courthouse
   * - Courtroom: Courtroom 1 Level 3
   * - Output: Brisbane C…(…m 1 Level 3)
   */
  balancedTruncation(stringA: string, stringB: string, maxLength: number): string {
    // The mid point essentially (-2 for the parenthesis)
    const charsToLeaveAfterTruncate = maxLength / 2 - 2
    const totalLength = stringA.length + stringB.length
    if (totalLength <= maxLength) {
      return `${stringA}(${stringB})`
    } else if (stringA.length <= charsToLeaveAfterTruncate) {
      // -1 cause we have a single ellipses, rather than 2
      const amount = charsToLeaveAfterTruncate + (charsToLeaveAfterTruncate - stringA.length - 1)
      const truncatedCourtroom = this.truncate(stringB, 'start', amount)
      return `${stringA}(${truncatedCourtroom})`
    } else if (stringB.length <= charsToLeaveAfterTruncate) {
      // -1 cause we have a single ellipses, rather than 2
      const amount = charsToLeaveAfterTruncate + (charsToLeaveAfterTruncate - stringB.length) - 1
      const truncatedCourthouse = this.truncate(stringA, 'end', amount)
      return `${truncatedCourthouse}(${stringB})`
    }
    const truncatedCourtroom = this.truncate(stringB, 'start', charsToLeaveAfterTruncate)
    const truncatedCourthouse = this.truncate(stringA, 'end', charsToLeaveAfterTruncate)

    return `${truncatedCourthouse}(${truncatedCourtroom})`
  }

  truncate(text: string, position: 'start' | 'end', amount: number): string {
    if (text.length <= amount) {
      return text
    }

    const ellipsis = '…'

    if (position === 'end') {
      return text.slice(0, amount) + ellipsis
    }
    return ellipsis + text.slice(text.length - amount - 1)
  }
}
